import React, { Component } from 'react'
import { SetsCard, SetItemsCard, SequenceSetItemsPane, SetPropertiesPane, } from './ManageSetsComponents'
import { Row, Col, Nav, NavItem, NavLink, TabContent, } from 'reactstrap'
import { Link, } from 'react-router-dom'
import classnames from 'classnames'

/*
  <ManageSets 
    setSearch={this.state.setSearch} 
    handleSetSearchChange={this.handleSetSearchChange}
    addSetName={this.state.addSetName}
    handleAddSetNameChange={this.handleAddSetNameChange}
    handleSubmitAddSet={this.handleSubmitAddSet}
    searchedSets={searchedSets}
    activeSet={this.props.activeSet}
    handleDeleteSet={this.handleDeleteSet}
    filters={this.props.filters}
    setItemFilter={this.props.setItemFilter}
    removeItemFilter={this.props.removeItemFilter}
    filterBySelected={this.state.filterBySelected}
    filterText={this.state.filterText}
    handleFilterTextChange={this.handleFilterTextChange}
    handleFilterBySelectedChange={this.handleFilterBySelectedChange}
    resetFilterGenerator={this.resetFilterGenerator}
    items={this.props.items}
    sets={this.props.sets}
    nodes={this.props.nodes}
    handleAddContentToSet={this.handleAddContentToSet}
    handleRemoveContentFromSet={this.handleRemoveContentFromSet}
    pane={this.state.pane}
    handleChangeSequence={this.handleChangeSequence}
  />

*/

/*
  Have to fix Link inside NavLink once UI work is done.
*/

class ManageSets extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: '1'
    }
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  render() {
    return (
      <Row>
        <SetsCard 
          setSearch={this.props.setSearch} 
          handleSetSearchChange={this.props.handleSetSearchChange}
          addSetName={this.props.addSetName}
          handleAddSetNameChange={this.props.handleAddSetNameChange}
          handleSubmitAddSet={this.props.handleSubmitAddSet}
          searchedSets={this.props.searchedSets}
          activeSet={this.props.activeSet}
          handleDeleteSet={this.props.handleDeleteSet}
          locationSearch={this.props.locationSearch}
        />
        <Col md='12' lg='8' xl='9'>
          <Nav tabs>
            <NavItem>
              <Link to='?pane=1'>
                <NavLink
                  className={classnames({ active: this.props.pane === '1', m2clickable: true})}
                >
                  Assign Content
                </NavLink>
              </Link>
            </NavItem>
            <NavItem>
              <Link to='?pane=2'>
                <NavLink
                  className={classnames({ active: this.props.pane === '2', m2clickable: true})}
                  onClick={() => this.toggle('2')}
                >
                  Sequence
                </NavLink>
              </Link>
            </NavItem>
            <NavItem>
              <Link to='?pane=3'>
                <NavLink
                  className={classnames({ active: this.props.pane === '3', m2clickable: true})}
                >
                  Properties
                </NavLink>
              </Link>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.props.pane}>
            <SetItemsCard 
              filters={this.props.filters}
              setItemFilter={this.props.setItemFilter}
              removeItemFilter={this.props.removeItemFilter}
              filterBySelected={this.props.filterBySelected}
              filterText={this.props.filterText}
              handleFilterTextChange={this.props.handleFilterTextChange}
              handleFilterBySelectedChange={this.props.handleFilterBySelectedChange}
              resetFilterGenerator={this.props.resetFilterGenerator}
              items={this.props.items}
              sets={this.props.sets}
              activeSet={this.props.activeSet}
              nodes={this.props.nodes}
              handleAddContentToSet={this.props.handleAddContentToSet}
              handleRemoveContentFromSet={this.props.handleRemoveContentFromSet}
            />
            <SequenceSetItemsPane 
              items={this.props.items}
              sets={this.props.sets}
              activeSet={this.props.activeSet}
              handleChangeSequence={this.props.handleChangeSequence}              
            />
            <SetPropertiesPane
              nodes={this.props.nodes}
              sets={this.props.sets}
              activeSet={this.props.activeSet}
            />
          </TabContent>
        </Col>
      </Row>
    )
  }
}

export default ManageSets

/*
export default function ManageSets(props) {
  return (
    <Row>
      <SetsCard 
        setSearch={props.setSearch} 
        handleSetSearchChange={props.handleSetSearchChange}
        addSetName={props.addSetName}
        handleAddSetNameChange={props.handleAddSetNameChange}
        handleSubmitAddSet={props.handleSubmitAddSet}
        searchedSets={props.searchedSets}
        activeSet={props.activeSet}
        handleDeleteSet={props.handleDeleteSet}
      />
      <SetItemsCard 
        filters={props.filters}
        setItemFilter={props.setItemFilter}
        removeItemFilter={props.removeItemFilter}
        filterBySelected={props.filterBySelected}
        filterText={props.filterText}
        handleFilterTextChange={props.handleFilterTextChange}
        handleFilterBySelectedChange={props.handleFilterBySelectedChange}
        resetFilterGenerator={props.resetFilterGenerator}
        items={props.items}
        sets={props.sets}
        activeSet={props.activeSet}
        nodes={props.nodes}
        handleAddContentToSet={props.handleAddContentToSet}
        handleRemoveContentFromSet={props.handleRemoveContentFromSet}
      />
    </Row>
  )
}

*/


// WEBPACK FOOTER //
// ./src/components/Content/ManageSets.js